import React from 'react'
import type { AboutPage as AboutPageData, Media } from 'api/api.types'
import { parseHtml } from 'utils/htmlParserWithCustomLinks'
import { Picture } from 'components/Utility/Media/Picture'
import styles from './AboutPage.module.scss'

type AboutPageProps = {
  page: AboutPageData,
}

const BlockPicture: React.FC<{ media: Media | null, className: string }> = ({ media, className }) => {
  if (!media) {
    return null
  }
  return (
    <Picture
      className={className}
      image={media.image}
      desktopType={'fullscreen-desktop'}
      mobileType={'fullscreen-mobile'}
      alt={media.type === 'image' ? media.imageAlt : undefined}
    />
  )
}

export const AboutPage: React.FC<AboutPageProps> = ({ page }) => (
  <div className={styles.container}>
    <h1 className={styles.title}>{page.title}</h1>
    {page.templateVars.pageVars.blocks.map((item, index) => (
      <div key={index} data-index={index} className={styles.block}>
        <div className={styles.blockText}>
          <div className={styles.blockTitle}>{item.title}</div>
          <div className={styles.blockContent + ' text-content'}>{parseHtml(item.content || '')}</div>
        </div>
        <div className={styles.blockImage}>
          <div className={styles.blockImagesContainer}>
            <BlockPicture media={item.imageSmall} className={styles.smallImage} />
            <BlockPicture media={item.image} className={styles.mainImage} />
          </div>
        </div>
      </div>
    ))}
  </div>
)
